//Permanent
const brand = "Depor";
const twitterAccount = "tuitdepor";    
const urlBrand = "https://depor.com/";
const urlPortadaEspeciales = "https://especiales.depor.com/especiales/index.html";
const domainMarca = "https://especiales.depor.com/";
const domainAssets = 'https://d1ts5g4ys243sh.cloudfront.net/proyectos_especiales_general/depor/prod/';
const slugCommonAssets = 'elementos-comunes/';
const urlCommonAssets = `${domainAssets}${slugCommonAssets}`;

//Variable
const socialShareText = `Juan Reynoso, nuevo entrenador de la Selección Peruana de fútbol rumbo al Mundial 2026 | ${brand}`;
const slugEspecial = "juan-reynoso-perfil-numeros-palmares-nuevo-entrenador-seleccion-peruana-eliminatorias-mundial-2026-multimedia-nndd";
const urlEspecial = `${domainMarca}${slugEspecial}/index.html`;
const urlAssets = `${domainAssets}${slugEspecial}`;
const urlJson = `${domainAssets}${slugEspecial}/json/photogallery.json`;
const queryStringText = 'dato';

export { 
    brand,
    queryStringText,
    twitterAccount, 
    urlBrand, 
    urlPortadaEspeciales, 
    domainMarca, 
    domainAssets, 
    urlCommonAssets, 
    socialShareText, 
    slugEspecial, 
    urlEspecial, 
    urlAssets, 
    urlJson 
}